import Rox from 'rox-browser';

export const FlagsMinipack = {
  minipack_enable: new Rox.Flag(false),
};

export function initFlagsMinipack() {
  // register flags with namespaces for better grouping
  Rox.register("featureMinipack", FlagsMinipack);
}
